module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e18bbf611f2a2e43afc0.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/assets/plugins/fonts/glyphicons-halflings-regular.ttf
// module id = ../../../../../src/assets/plugins/fonts/glyphicons-halflings-regular.ttf
// module chunks = styles